export interface SubmittedClaimDetails {
  id: string | number;
  source: string;
  submittedByUsername: string;
  submissionDate: string;
  claimDetail: {
    id: string;
    claimNumber: string;
    secondaryId: string;
    claimStatus: string;
    remarks: string;
    statusReason: string;
    claimType: string;
    claimSubtype: string;
    serviceTypeId: string;
    serviceDate: string;
    serviceDateAdditionalText: string;
    serviceEndDate: string;
    memberCoverageId: string;
    patient: {
      id: string;
      name: Name;
      taxId: string;
      addresses: Address[];
      phoneNumbers: PhoneNumber[];
    };
    provider: Provider;
    providers: Provider[];
    procedures: [
      {
        id: string;
        code: string;
        description: string;
        effectiveDate: string;
        terminationDate: string;
        codingSystem: string;
        category: string;
      },
    ];
    diagnoses: Diagnosis[];
    patientAccidentInformation: {
      id: string;
      accidentType: string;
      stateCode: string;
      dateOfAccident: string;
      faultPerson: string;
    };
    documentIds: [string];
    billingFacilityLocationId: string;
  };
  claimLines: [
    {
      id: string;
      lineNumber: string;
      serviceFromDate: string;
      serviceToDate: string;
      billedAmount: string;
      serviceUnits: string;
      modifiers: [
        {
          id: string;
          value: string;
          description: string;
        },
      ];
      procedures: [
        {
          id: string;
          code: string;
          description: string;
          effectiveDate: string;
          terminationDate: string;
          codingSystem: string;
          category: string;
        },
      ];
      placeOfServiceCode: string;
      providers: Provider[];
      diagnosesInformation: [
        {
          id: string;
          diagnosis: Diagnosis;
          priority: string;
        },
      ];
      serviceUnitType: string;
      serviceUnitQuantity: string;
      additionalProperties: DentalAdditionalProperties[];
    },
  ];
  contactInformation: {
    id: string;
    name: Name;
    gender: string;
    title: string;
    phoneNumbers: PhoneNumber[];
    addresses: Address[];
    contactRelationship: string;
    contactType: string;
    contactTypeDisplayText: string;
    fax: string;
    emailAddress: string;
    isPrimary: true;
  };
  otherInsurerName?: string;
  otherPolicyNumber?: string;
  otherPolicyHolderName?: string;
  submissionStatus?: string;
  additionalProperties: DentalAdditionalProperties[];
  submissionRequestType: string;
  claimsubmissiondocument?: ClaimSubmissionDocumentData[];
}

export interface ClaimSubmissionDocumentData {
  documentId?: number;
  size?: number;
  link?: string;
  name?: string;
  type?: string;
}

export interface Name {
  firstName: string;
  lastName: string;
  middleName: string;
  prefix: string;
  suffix: string;
  postNominalLetters: string;
  fullName: string;
}

export interface Address {
  id: string;
  effectiveDate: string;
  streetName1: string;
  streetName2: string;
  streetName3: string;
  cityName: string;
  countyName: string;
  countyCode: string;
  zipCode: string;
  state: string;
  countryName: string;
  countryCode: string;
  isPrimary: true;
  addressType: string;
}

export interface DentalAdditionalProperties {
  category: string;
  propertyDictionary: {
    areaOfMouth: string;
    toothNumberOrLetter: string;
    toothSurface: string;
    frequency: string;
    isOrthodonticTreatmentIncluded: string;
    expectedLengthOfTreatment: string;
    totalChargeForActiveTreatment: string;
    isInitialTreatment: boolean;
    appliancePlacementDate: string;
    isProsthesisReplacementIncluded: boolean;
    prosthesisReplacementReason: string;
    prosthesisReplacementReasonDescription: string;
  };
}

export interface Provider {
  id: string;
  number: string;
  name: string;
  npi: string;
  taxId: string;
  address: Address;
}

export interface Diagnosis {
  id: string;
  code: string;
  description: string;
  type: string;
}
export interface PhoneNumber {
  id: number;
  phoneNumber: string;
  extension: string;
  isPrimary: true;
  type: string;
}
